import {
  NETSCAN_SETUP_GET,
  NETSCAN_SETUP_POST,
  MAXTHROUGHPUT_GET,
  MAXTHROUGHPUT_POST,
  FIBERLENGTHLOSS_SETUP_GET,
  FIBERLENGTHLOSS_SETUP_POST,
  SUBTESTETTINGS_GET,
  SUBTESTSETTINGS_POST,
  QUALIFICATION_SETUP_GET,
  QUALIFICATION_SETUP_POST
} from "../actions/subtestActions";
import { Suspense } from "react";
const SUBTEST_SELECTED_SUCCESS = "SUBTEST_SELECTED_SUCCESS";
const SUBTEST_SELECTED_FAIL = "SUBTEST_SELECTED_FAIL";
const SUBTEST_PING_SELECTED_SUCCESS = "SUBTEST_PING_SELECTED_SUCCESS";
const SUBTEST_PING_SELECTED_FAIL = "SUBTEST_PING_SELECTED_FAIL";
const SUBTEST_PING_UPDATE_SUCCESS = "SUBTEST_PING_UPDATE_SUCCESS";
const SUBTEST_PING_UPDATE_FAIL = "SUBTEST_PING_UPDATE_FAIL";
const SUBTEST_TR_SELECTED_SUCCESS = "SUBTEST_TR_SELECTED_SUCCESS";
const SUBTEST_TR_SELECTED_FAIL = "SUBTEST_TR_SELECTED_FAIL";
const SUBTEST_TR_UPDATE_SUCCESS = "SUBTEST_TR_UPDATE_SUCCESS";
const SUBTEST_TR_UPDATE_FAIL = "SUBTEST_TR_UPDATE_FAIL";
const SUBTEST_UPTIME_GET_SUCCESS = "SUBTEST_UPTIME_GET_SUCCESS";
const SUBTEST_UPTIME_GET_FAIL = "SUBTEST_UPTIME_GET_FAIL";
const SUBTEST_UPTIME_UPDATE_SUCCESS = "SUBTEST_UPTIME_UPDATE_SUCCESS";
const SUBTEST_UPTIME_UPDATE_FAIL = "SUBTEST_UPTIME_UPDATE_FAIL";
const SUBTEST_WIREMAP_GET_SUCCESS = "SUBTEST_WIREMAP_GET_SUCCESS";
const SUBTEST_WIREMAP_GET_FAIL = "SUBTEST_WIREMAP_GET_FAIL";
const SUBTEST_WIREMAP_CABLELIST_GET_SUCCESS =
  "SUBTEST_WIREMAP_CABLELIST_GET_SUCCESS";
const SUBTEST_WIREMAP_CABLELIST_GET_FAIL = "SUBTEST_WIREMAP_CABLELIST_GET_FAIL";
const SUBTEST_WIREMAP_CABLELIST_UPDATE_SUCCESS =
  "SUBTEST_WIREMAP_CABLELIST_UPDATE_SUCCESS";
const SUBTEST_WIREMAP_CABLELIST_UPDATE_FAIL =
  "SUBTEST_WIREMAP_CABLELIST_UPDATE_FAIL";
const CABLE_DELETE_SUCCESS = "CABLE_DELETE_SUCCESS";
const CABLE_DELETE_FAIL = "CABLE_DELETE_FAIL";
const SUBTEST_WIREMAP_UPDATE_SUCCESS = "SUBTEST_WIREMAP_UPDATE_SUCCESS";
const SUBTEST_WIREMAP_UPDATE_FAIL = "SUBTEST_WIREMAP_UPDATE_FAIL";

//const SUBTEST_LOADED = "SUBTEST_LOADED";
// const SUBTESTT_TARGET_SUCCESS = "SUBTESTT_TARGET_SUCCESS";
// const SUBTESTT_TARGET_FAIL = "SUBTESTT_TARGET_FAIL";
// const SUBTESTT_LOADED = "SUBTESTT_LOADED";
const SUCCESS = "_SUCCESS";
const FAIL = "_FAIL";

export const defaultCustomerState = {
  error: false,
  errorMessage: null
};

export default (state = defaultCustomerState, action) => {
  switch (action.type) {
    case SUBTEST_PING_SELECTED_SUCCESS:
      return {
        ...state,
        selectedTestResult: action.payload.data,
        subTestId: action.payload.data.type,
        error: false
      };
    case SUBTEST_PING_SELECTED_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case SUBTEST_PING_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          subTestPingUpdated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case SUBTEST_PING_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case SUBTEST_TR_SELECTED_SUCCESS:
      return {
        ...state,
        selectedTrResult: action.payload.data,
        subTestId: action.payload.data.type,
        error: false
      };
    case SUBTEST_TR_SELECTED_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case SUBTEST_TR_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          subTestPingUpdated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case SUBTEST_TR_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case NETSCAN_SETUP_GET + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false,
          netScan: action.payload.data
        };
      }
    }
    case NETSCAN_SETUP_GET + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case NETSCAN_SETUP_POST + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false
        };
      }
    }
    case NETSCAN_SETUP_POST + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case SUBTEST_UPTIME_GET_SUCCESS:
      return {
        ...state,
        upTime: action.payload.data,
        error: false
      };
    case SUBTEST_UPTIME_GET_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case SUBTEST_UPTIME_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          upTimeUpdated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case SUBTEST_UPTIME_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case MAXTHROUGHPUT_GET + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false,
          maxThroughPut: action.payload.data
        };
      }
    }
    case MAXTHROUGHPUT_GET + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case MAXTHROUGHPUT_POST + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false
        };
      }
    }
    case MAXTHROUGHPUT_POST + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case SUBTEST_WIREMAP_GET_SUCCESS:
      return {
        ...state,
        wireMap: action.payload.data,
        error: false
      };
    case SUBTEST_WIREMAP_GET_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case SUBTEST_WIREMAP_CABLELIST_GET_SUCCESS: {
      return {
        ...state,
        cableList: action.payload.data
      };
    }
    case SUBTEST_WIREMAP_CABLELIST_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case SUBTEST_WIREMAP_CABLELIST_UPDATE_SUCCESS: {
      return {
        ...state
      };
    }
    case SUBTEST_WIREMAP_CABLELIST_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CABLE_DELETE_SUCCESS: {
      return {
        ...state,
        deletedCable: action.payload.data
      };
    }
    case SUBTESTETTINGS_GET + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false,
          subtestSettings: action.payload.data
        };
      }
    }
    case SUBTESTETTINGS_GET + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case SUBTESTSETTINGS_POST + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false
        };
      } else {
        return {
          ...state,
          error: true
        };
      }
    }
    case SUBTESTSETTINGS_POST + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case SUBTEST_WIREMAP_UPDATE_SUCCESS: {
      return {
        ...state
      };
    }
    case SUBTEST_WIREMAP_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case FIBERLENGTHLOSS_SETUP_GET + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false,
          fiberLengthLoss: action.payload.data
        };
      }
    }
    case FIBERLENGTHLOSS_SETUP_GET + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case FIBERLENGTHLOSS_SETUP_POST + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false
        };
      }
    }
    case FIBERLENGTHLOSS_SETUP_POST + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case QUALIFICATION_SETUP_GET + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false,
          qualification: action.payload.data
        };
      }
    }
    case QUALIFICATION_SETUP_GET + FAIL: {
      return {
        ...state,
        error: true
      };
    }
    case QUALIFICATION_SETUP_POST + SUCCESS: {
      if (action.payload.data) {
        return {
          ...state,
          error: false
        };
      }
    }
    case QUALIFICATION_SETUP_POST + FAIL: {
      return {
        ...state,
        error: true
      };
    }

    default:
      return state;
  }
};
